export default {
  data() {
    return {
      currentTab: 0,
    };
  },

  watch: {
    selectedTab(newVal) {
      this.currentTab = newVal;
    },
  },

  props: {
    pageNames: {
      type: Array,
      default: () => [],
    },
    selectedTab: {
      type: Number,
      default: 0,
    },
    pageWarnings: {
      type: Object,
      default: () => ({}),
    },
    showTabs: {
      type: Boolean,
      default: true,
    },
    displayStatus: {
      type: Function,
      default: () => () => false,
    }
  },

  methods: {
    updateCurrentTab(index) {
      this.$emit('clicked-tab', index);
    },
  },

  mounted() {
    this.currentTab = this.selectedTab;
  }  
}